import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type VariantKitDataQueryVariables = Types.Exact<{
  pk: Types.Scalars['Int']['input'];
  cartLine?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  cartType?: Types.InputMaybe<Types.CartTypeEnum>;
}>;


export type VariantKitDataQuery = { productVariant: { id: string, customizeKitData: any | null } | null };


export const VariantKitDataDocument = gql`
    query VariantKitData($pk: Int!, $cartLine: Int, $cartType: CartTypeEnum = DEFAULT) {
  productVariant(pk: $pk) {
    id
    customizeKitData(cartLine: $cartLine, cartType: $cartType)
  }
}
    `;

/**
 * __useVariantKitDataQuery__
 *
 * To run a query within a React component, call `useVariantKitDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useVariantKitDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVariantKitDataQuery({
 *   variables: {
 *      pk: // value for 'pk'
 *      cartLine: // value for 'cartLine'
 *      cartType: // value for 'cartType'
 *   },
 * });
 */
export function useVariantKitDataQuery(baseOptions: Apollo.QueryHookOptions<VariantKitDataQuery, VariantKitDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VariantKitDataQuery, VariantKitDataQueryVariables>(VariantKitDataDocument, options);
      }
export function useVariantKitDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VariantKitDataQuery, VariantKitDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VariantKitDataQuery, VariantKitDataQueryVariables>(VariantKitDataDocument, options);
        }
export type VariantKitDataQueryHookResult = ReturnType<typeof useVariantKitDataQuery>;
export type VariantKitDataLazyQueryHookResult = ReturnType<typeof useVariantKitDataLazyQuery>;
export type VariantKitDataQueryResult = Apollo.QueryResult<VariantKitDataQuery, VariantKitDataQueryVariables>;
export function refetchVariantKitDataQuery(variables: VariantKitDataQueryVariables) {
      return { query: VariantKitDataDocument, variables: variables }
    }